import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import ReactGA from "react-ga4";

import Homepage from "./pages/homepage";
import About from "./pages/about";
import Projects from "./pages/projects";
import Portfolio from "./pages/portfolio";
import ReadArticle from "./pages/readArticle";
import Contact from "./pages/contact";
import Notfound from "./pages/404";
import ChatTest from "./pages/chatbot";
import { TRACKING_ID } from "./data/tracking";
import "./app.css";



function App() {
	useEffect(() => {
		if (TRACKING_ID !== "") {
			ReactGA.initialize(TRACKING_ID);
		}
	}, []);

	return (
		<div className="App">
			<Routes>
				<Route path="/" element={<Homepage />} />
				<Route path="/about" element={<About />} />
				<Route path="/projects" element={<Projects />} />
				<Route path="/portfolio" element={<Portfolio />} />
				<Route path="/portfolio/:slug" element={<ReadArticle />} />
				<Route path="/contact" element={<Contact />} />
				<Route path="/chatbot" element={<ChatTest/>} />
				<Route path="*" element={<Notfound />} />
			</Routes>
		</div>
	);
}

export default App;
